<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Time Table Constraint Assignment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="9" sm="4" md="4">
                            <v-autocomplete rounded dense required v-model="faculty" :items="instructor"
                                item-text="name" return-object label="Instructor" outlined persistent-hint
                                hint="Please Select Instructor"></v-autocomplete>
                        </v-col>
                        <v-col cols="9" sm="4" md="4">
                            <v-autocomplete rounded dense required v-model="constraint" :items="tconstraint"
                                item-text="name" return-object label="Constraint" outlined persistent-hint
                                hint="Please Select Constraint"></v-autocomplete>
                        </v-col>
                        <v-col cols="3" sm="1" md="1">
                            <v-btn color="primary" @click="fetch" class="mt-1" block>Fetch</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>


        <v-card class="box" v-if="showTable">
            <v-data-table :headers="headers" :items="assignment_list" class="elevation-1 mytable" dense sort-by="srno"
                :search="search">
                <template v-slot:top>
                    <div class="d-flex justify-end">
                        <v-btn class="mt-2" color="primary" rounded @click="add_new_installment"
                            :loading="fetch_btn_load">
                            + Add Constraint Assignment
                        </v-btn>
                        <v-col sm="1" md="1" cols="4">
                            <v-btn class="mt-0" color="success" dark @click="exportFilteredData" outlined
                                :loading="loader" block>
                                <v-icon small color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>
                    </div>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete rounded dense required
                                                        v-model="editedItem.instructor" :items="instructor"
                                                        item-text="name" item-value="id" label="Instructor" outlined
                                                        persistent-hint
                                                        hint="Please Select Instructor"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete rounded dense required
                                                        v-model="editedItem.constraint" :items="tconstraint_list"
                                                        item-text="name" item-value="id" label="Constraint" outlined
                                                        persistent-hint
                                                        hint="Please Select Constraint"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete rounded dense required
                                                        v-model="editedItem.parameter" :items="parameter_list1"
                                                        item-text="name" item-value="id" label="Key" outlined
                                                        persistent-hint hint="Please Select Key"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.value" persistent-hint
                                                        label="Enter Value "> </v-text-field>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar size="32" class="mr-2" color="red lighten-4">
                            <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                        </v-avatar>

                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <!-- edit dialog  -->
        <v-dialog v-model="edit_dialog" max-width="700px">
            <v-card>
                <v-form v-model="valid">
                    <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete rounded dense required v-model="editedItem.instructor"
                                        :items="instructor" item-text="name" item-value="id" label="Instructor" outlined
                                        persistent-hint hint="Please Select Instructor"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete rounded dense required v-model="editedItem.constraint"
                                        :items="tconstraint_list" item-text="name" item-value="id" label="Constraint"
                                        outlined persistent-hint hint="Please Select Constraint"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete rounded dense required v-model="editedItem.parameter"
                                        :items="parameter_list1" item-text="name" item-value="id" label="Key" outlined
                                        persistent-hint hint="Please Select Key"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.value" persistent-hint label="Enter Value ">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                        <v-btn class="mb-2 button" color="primary" @click="save_edited" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            edit_dialog: false,
            fetch_btn_load: false,
            showTable: false,
            headers: [
                { text: "Sr. No.", value: "srno" },
                {
                    text: "Instructor",
                    align: "left",
                    sortable: false,
                    value: "instructor",
                },
                {
                    text: "Constraint",
                    align: "left",
                    sortable: false,
                    value: "constraint",
                },
                {
                    text: "Key",
                    align: "left",
                    sortable: false,
                    value: "parameter",
                },
                {
                    text: "Value",
                    align: "left",
                    sortable: false,
                    value: "value",
                },

                { text: "Actions", value: "action", sortable: false },
            ],
            assignment_list: [],
            parameter_list1: [],
            tconstraint_list: [],
            instructor: [],
            tconstraint: [{ id: "all", name: "All" }],
            constraint: "",
            faculty: "",

            editedIndex: -1,
            editedItem: {
                id: "",
                constraint: "",
                parameter: "",
                value: "",
                instructor: "",

            },
            defaultItem: {
                id: "",
                constraint: "",
                parameter: "",
                value: "",
                instructor: "",

            },

        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Time Table Constraint Assignment" : "Edit Time Table Constraint Assignment";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        mounted() {
            this.onLoad();
        },
        methods: {


            exportFilteredData() {

                const exportData = this.assignment_list .map(item => ({
                    "Sr. No.": item.srno,
                    "Instructor": item.instructor,
                    "TimeTableConstraint": item.constraint,
                    "TimeTableConstraintParameter": item.parameter,
                    "Value": item.value,
                    

                }));


                import("xlsx").then(XLSX => {
                    const worksheet = XLSX.utils.json_to_sheet(exportData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "TimeTableConstraintParameter");
                    XLSX.writeFile(workbook, "TimeTableConstraintAssignment.xlsx");
                });
            },
            add_new_installment() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.assignment_list.indexOf(item);

                this.editedItem = {
                    id: item.id,
                    value: item.value,
                    instructor: item.instructor_id,       // use the ID only
                    constraint: item.constraint_id,       // use the ID only
                    parameter: item.parameter_id || null  // use if parameter list is optional
                };

                this.edit_dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AITimeTable/addTimeTableConstraintAssignment")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            // this.assignment_list = res.data.assignment_list;
                             this.assignment_list = res.data.assignment_list.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                            this.tconstraint_list = res.data.tconstraint_list;
                            this.parameter_list1 = res.data.parameter_list1;
                            this.tconstraint = res.data.tconstraint;
                            this.instructor = res.data.instructor;
                            this.tconstraint.unshift({ id: "all", name: "All" });



                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            save() {
                if (!this.editedItem.instructor) {
                    this.showSnackbar("#b71c1c", "Instructor is required.");
                    return;
                }

                if (!this.editedItem.constraint) {
                    this.showSnackbar("#b71c1c", "Constraint is required.");
                    return;
                }



                if (!this.editedItem.parameter) {
                    this.showSnackbar("#b71c1c", "Constraint Parameter is required.");
                    return;
                }

                if (!this.editedItem.value || this.editedItem.value.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Assignment value is required.");
                    return;
                }

                // alert("save-----" +this.editedItem.instructor)
                const data = {
                    data: this.editedItem,
                    constraint: this.editedItem.constraint,
                    parameter: this.editedItem.parameter,
                    instructor: this.editedItem.instructor,
                    value: this.editedItem.value,

                };
                axios
                    .post("/AITimeTable/saveTimeTableConstraintAssignment", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraintAssignment Added Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraintAssignment Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            save_edited() {

                if (!this.editedItem.value || this.editedItem.value.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Assignment value is required.");
                    return;
                }

                //  alert("save-----" +this.editedItem.id)
                const data = {
                    data: this.editedItem,
                    constraint: this.editedItem.constraint,
                    parameter: this.editedItem.parameter,
                    instructor: this.editedItem.instructor,
                    value: this.editedItem.value,
                    assignment: this.editedItem.id,

                };
                axios
                    .post("/AITimeTable/editTimeTableConstraintAssignment", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraintAssignment Updated Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraintAssignment Already Present!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            deleteItem(item) {

                // Optional: confirm before deleting
                if (!confirm("Are you sure you want to delete this record?")) return;

                this.overlay = true;
                axios
                    .post("/AITimeTable/deleteTimeTableConstraintAssignment", {
                        id: item.id
                    })
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "Time Table Constraint Assignment Deleted successfully!");
                            this.onLoad(); // Refresh the table
                        } else {
                            this.showSnackbar("#b71c1c", "Delete failed.");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.showSnackbar("#b71c1c", "Something went wrong.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },

            fetch() {
                const constraintId = this.constraint && this.constraint.id !== "all" ? this.constraint.id : null;
                const instId = this.faculty && this.faculty.id !== "all" ? this.faculty.id : null;

                this.overlay = true;

                axios
                    .post("/AITimeTable/getTimeTableConstraintAssignment", {
                        constraintId: constraintId,
                        instId: instId
                    })
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.assignment_list = res.data.parameterList.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                            this.showTable = true;
                            this.showSnackbar("#4caf50", "Filtered list loaded.");
                        } else {
                            this.assignment_list = [];
                            this.showTable = false;
                            this.showSnackbar("#b71c1c", res.data.msg || "No data found.");
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        this.showSnackbar("#b71c1c", "Failed to fetch data.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },





        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>